export enum CounterActions {
  DO_NOTHING = 'do-nothing',
  REDIRECT = 'redirect',
}
